<script>
    /*
    	MyServicesList.svelte

        NOTE: these are the full service records, not the lightweight indexes.
    */

    import { onMount } from 'svelte';
    
    // TCARE components
    import MyServicesListItem from './MyServicesListItem.svelte';
    // import RemoveResourcePopup from '../popups/RemoveResourcePopup.svelte';

    // $: isShowingPopup = false;

    export let services;
    export let onShowPopup;                 // list item sends back service object
    
    onMount(() => {
        // console.log('MyServicesList onMount');
        // console.log('services:');
        // console.log(services);
    })

    /*
    // pass to and called by the list items
    const onShowPopup = (service) => {
        currentService = service;
        isShowingPopup = true;
    }
    */

    /*
    const _onPopupCancel = () => {
        // console.log('MyServicesList _onPopupCancel');
        isShowingPopup = false;
    }
    
    const _onPopupRemove = (service) => {
        // console.log('MyServicesList _onPopupRemove');
        isShowingPopup = false;
        onShowPopup(service);
    }
    */


</script>

<style>
    .my-services-list {
        width: 80%;
        margin: auto;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="my-services-list">
    {#each services as service}
        <MyServicesListItem {service} {onShowPopup} />
    {/each}
</div>


<!-- TODO: remove currentService - is only used to display the service name -->
<!--
{#if isShowingPopup}
    <RemoveResourcePopup 
        onCancel={_onPopupCancel} 
        onRemove={_onPopupRemove} 
        {currentService}
    />
{/if}
-->
